import { render, staticRenderFns } from "./EventWizard_EventAgenda.vue?vue&type=template&id=612d8549&scoped=true&"
import script from "./EventWizard_EventAgenda.vue?vue&type=script&lang=js&"
export * from "./EventWizard_EventAgenda.vue?vue&type=script&lang=js&"
import style0 from "./EventWizard_EventAgenda.vue?vue&type=style&index=0&id=612d8549&lang=scss&%2C=true&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612d8549",
  null
  
)

export default component.exports